import {Routes} from '@angular/router';
import {SupportComponent} from '@pages/support/support/support.component';
import {FilemanagerComponent} from '@pages/filemanager/filemanager/filemanager.component';

export const FILEMANAGER_ROUTES: Routes = [
  {
    path: '',
    component: FilemanagerComponent,
    data: {
      title: 'Documenti',
      titleKey: 'menu.documents',
      urls: [
        {title: 'Dashboard', url: '/dashboard'},
        {title: 'Filemanager'},
      ],
    }
  }
];
